<template>
  <div>
    <div class="b-row">
      <b-card
        title="Termo de Reserva"
        subtitle="Leia o termo antes de efetivar sua reserva"
      >
        <!-- eslint-disable-next-line -->
        <p v-html="termoReservaEmAndamento" />
        <b-row
          b-type="flex"
          b-justify="space-between"
        >
          <b-col
            b-type="flex"
            b-w="6"
          >
            <b-button
              variant="outline-primary"
              @click="cancelarReserva()"
            >
              <feather-icon icon="ArrowLeftIcon" />
              Voltar
            </b-button>
          </b-col>
          <b-col
            b-type="flex"
            b-w="6"
            align="right"
          >
            <b-button
              variant="primary"
              :disabled="busy"
              @click="confirmarReserva()"
            >
              <b-spinner
                v-if="busy"
                small
                variant="light"
              />
              <span>{{ busy ? ' Aguarde...' : ' Confirmar' }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      busy: false,
    }
  },
  computed: {
    reservaEmAndamento() {
      return this.$store.state.reserva.reservaEmAndamento
    },
    termoReservaEmAndamento() {
      return this.$store.state.reserva.termoReservaEmAndamento
    },
  },
  methods: {
    clearAll() {
      this.$store.dispatch('reserva/clearAll')
    },
    cancelarReserva() {
      this.$store
        .dispatch('reserva/reservaEmAndamento', {})
        .then(() => this.$router.back())
    },
    setBusy(val) {
      this.busy = val
    },
    confirmarReserva() {
      this.setBusy(true)
      this.$store
        .dispatch('reserva/confirmarReserva', {
          reservaEmAndamento: this.reservaEmAndamento,
        })
        .then(() => {
          this.setBusy(false)
          this.$toast.success('Confirmação de Reserva')
          this.clearAll()
          this.$router.push('/reservas')
        })
        .catch(err => {
          this.setBusy(false)
          this.$toast.error(
            `Não foi possível reservar =(, ${err
              && err.response
              && err.response.data}`,
          )
        })
    },
  },
}
</script>
